import React from 'react';
import { Text } from 'wix-ui-tpa/cssVars';
import { classes } from './EmptyState.st.css';
import { EmptyStateDataHooks } from './const';

export interface EmptyStateProps {
  title: string;
  subtitle?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ title, subtitle }) => {
  return (
    <div className={classes.root} data-hook={EmptyStateDataHooks.Main}>
      <Text
        className={classes.headerTitle}
        data-hook={EmptyStateDataHooks.EmptyStateTitle}
      >
        {title}
      </Text>
      <Text
        className={classes.headerTitle}
        data-hook={EmptyStateDataHooks.EmptyStateSubTitle}
      >
        {subtitle}
      </Text>
    </div>
  );
};
